/**
 * Lista de avisos de documentação do convênio, a mesma no detalhe do
 * agendamento, no cartão do mouse e na fila de pendências.
 * `onUnlinkedClick` (opcional): os avisos "falta vincular" viram botão que leva
 * ao "Vincular documento".
 * `alertAction` (opcional, no lugar do anterior): (aviso) => { label, onClick } ou
 * null; o aviso com ação vira botão com o rótulo à direita.
 */
import React from 'react';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import { ALERT_CRITICAL, isUnlinkedAlert, sortAlerts } from '../../utils/insuranceAlerts';
import styles from './InsuranceAlertList.module.css';

function actionOf(alert, alertAction, onUnlinkedClick) {
  if (alertAction) return alertAction(alert);
  if (onUnlinkedClick && isUnlinkedAlert(alert)) return { label: 'Vincular', onClick: onUnlinkedClick };
  return null;
}

function InsuranceAlertList({ alerts, dense = false, onUnlinkedClick, alertAction }) {
  const sorted = sortAlerts(alerts);
  if (sorted.length === 0) return null;
  return (
    <ul className={`${styles.list} ${dense ? styles.dense : ''}`}>
      {sorted.map((alert) => {
        const critical = alert.level === ALERT_CRITICAL;
        const Icon = critical ? ReportProblemOutlinedIcon : ScheduleOutlinedIcon;
        const className = `${styles.item} ${critical ? styles.critical : styles.info}`;
        const action = actionOf(alert, alertAction, onUnlinkedClick);
        if (action) {
          return (
            <li key={alert.code}>
              <button type="button" className={`${className} ${styles.action}`} onClick={action.onClick}>
                <Icon className={styles.icon} />
                <span>{alert.message}</span>
                <span className={styles.actionLabel}>{action.label}</span>
              </button>
            </li>
          );
        }
        return (
          <li key={alert.code} className={className}>
            <Icon className={styles.icon} />
            <span>{alert.message}</span>
          </li>
        );
      })}
    </ul>
  );
}

export default InsuranceAlertList;
